import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const getUserSessions: ApiFunc<`${typeof API.USER_SESSIONS}`, 'get'> = data =>
  instance.get(API.USER_SESSIONS, {
    params: data,
  })

export const logoutUserSession: ApiFunc<`${typeof API.USER_SESSION_LOGOUT}{id}`, 'post'> = data =>
  instance.post(`${API.USER_SESSION_LOGOUT}${'id' in data && prop('id', data)}`, {
    params: 'id' in data && dissoc('id', data),
  })

export const logoutAllUserSessions: ApiFunc<`${typeof API.USER_SESSIONS_LOGOUT_ALL}`, 'post'> = data =>
  instance.post(API.USER_SESSIONS_LOGOUT_ALL, null, {
    params: data,
  })
